import React from 'react';
import Input from 'components/Input';
import { withTranslation } from 'react-i18next';
import { useFormContext } from "react-hook-form";
import { UilTimes } from '@iconscout/react-unicons';
import { UisCheckCircle } from '@iconscout/react-unicons-solid';
// import CustomInput from 'components/CustomInput';

const StepThreeForm = ({ t }) => {

  const { formState: { errors } } = useFormContext();

  return (
    <>
      <div className="w-full mb-3">
        <Input
          name="password"
          type="password"
          label={t('registration.field.password')}
          labelwithin={true}
          classList='bg-input'
        />

        <div className="w-full mt-3">
          <Input
            name="password_confirmation"
            type="password"
            label={t('registration.field.password_confirmation')}
            labelwithin={true}
        />
        </div>
        <ul className="pl-3 text-sm mt-3">
          {
            [
              {
                key: 'min',
                value: t('misc.validations.min', { chars: 8 })
              },
              {
                key: 'caps',
                value: t('misc.validations.caps')
              },
              {
                key: 'nomail',
                value: t('misc.validations.nomail')
              },
              {
                key: 'num',
                value: t('misc.validations.num')
              }
            ].map(({ key, value }, index) => {
              return (
                <li className={`flex text-small items-center mb-1.5 ${errors?.password?.type === key ? 'text-failure' : null} text-primary`} key={`${index}_`}>
                  {errors?.password?.type === key ? <UilTimes className="mr-1" /> : <UisCheckCircle className="mr-1" />} <span>{value}</span>
                </li>
              )
            })
          }
        </ul>
      </div>

    </>
  )
}


export default withTranslation()(StepThreeForm);